import moment from 'moment';

import { TSchedule } from './types';

/** Пустой график для формы создания, когда у CRM/рабочего места ещё нет графика */
export function buildDefaultSchedule(crmId: number): TSchedule {
    return {
        id: null,
        crm_id: crmId,
        // владелец для типа; реальный при сохранении собирает useCreateSchedule
        owner_type: 'crm',
        owner_id: crmId,
        title: '',
        start_time: '08:00',
        end_time: '17:00',
        breaks: [
            {
                start_break_time: '12:00',
                end_break_time: '13:00',
            },
        ],
        day_offs: [],
        schedule_days: [],
        // паттерн интервала осмыслен только при schedule_type = 1 и выводится на бэке
        schedule: null,
        schedule_type: 0,
        exception_days: [],
        is_basic: 0,
        start_schedule_at: moment().add(2, 'day').format('YYYY-MM-DD'),
        schedule_template_id: null,
    };
}

export function getStartDate(scheduleOrigin) {
    const defStartDate = moment((scheduleOrigin as TSchedule)?.start_schedule_at, 'YYYY-MM-DD');
    const tomorrow = moment().add(1, 'days').set('hours', 0).set('minutes', 0).set('seconds', 0);
    console.log(defStartDate);
    console.log(tomorrow);
    if (defStartDate.isSameOrAfter(tomorrow)) return defStartDate.format('YYYY-MM-DD');
    else return tomorrow.format('YYYY-MM-DD');
}
